import { Link } from '@inertiajs/react';
import React from 'react';
import { Accent, accentIcon, accentText, accentBorderHover } from '../lib/accents';

export const ProgramCard: React.FC<{
  title: string;
  description: string;
  tags: string[];
  imageUrl: string;
  accent?: Accent;
}> = ({ title, description, tags, imageUrl, accent = 'primary' }) => (
  <div
    className={`h-full flex flex-col bg-card rounded-lg shadow-md overflow-hidden border border-border ${accentBorderHover[accent]} hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1`}
  >
    <img src={imageUrl} alt={title} className='w-full h-48 object-cover' />
    <div className='p-6 flex flex-col flex-grow'>
      <div className='flex flex-wrap gap-2 mb-2'>
        {tags.map((tag) => (
          <span key={tag} className={`${accentIcon[accent]} text-xs font-semibold px-2.5 py-0.5 rounded-full`}>
            {tag}
          </span>
        ))}
      </div>
      <h3 className='text-xl font-bold text-card-foreground mb-2 font-heading'>{title}</h3>
      <p className='text-muted-foreground mb-4 flex-grow'>{description}</p>
      <div className='mt-auto'>
        <Link href='/contact' className={`font-semibold ${accentText[accent]} hover:opacity-80 transition-opacity`}>
          Learn More &rarr;
        </Link>
      </div>
    </div>
  </div>
);
